import { FragmentStore } from '../runtime/stores/fragment'
import artifact from '$houdini/artifacts/InventoryOptionValueData'


// create the fragment store

export class InventoryOptionValueDataStore extends FragmentStore {
	constructor() {
		super({
			artifact,
			storeName: "InventoryOptionValueDataStore",
			variables: true,
			
		})
	}
}
